import { createStore, applyMiddleware, compose } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import socketMiddleware from '../redux/middleware/socketMiddleware';
import redirectMiddleware from '../redux/middleware/redirectMiddleware';
import { useHistory } from 'react-router-dom';

import SocketAPI from '../socketAPI/SocketAPI';

export default function configureStore(initialState) {
	// setup the socket connection
	const socketClient = new SocketAPI();
	// const history = useHistory();
	//
	const composeEnhancers =
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
	return createStore(
		rootReducer,
		initialState,
		composeEnhancers(
			applyMiddleware(
				thunk,
				logger,
				reduxImmutableStateInvariant(),
				// socket middleware
				socketMiddleware(socketClient),
				redirectMiddleware()
			)
		)
	);
}

const logger = (store) => (next) => (action) => {
	console.log('dispatching', action);
	let result = next(action);
	// console.log('next state', store.getState());
	return result;
};
